import { Model } from 'modules/core/lib/mobx-rest'

export interface IIncidenceNote {
  id: string
  content: string
  author_id: string
  author_name: string
  created_at: string
  author_avatar: string
  bookkeepers_management_incidences_id: string
}

class IncidenceNote extends Model<IIncidenceNote> {
  static urlRoot() {
    return '/bookkeepers_management/incidence_notes'
  }
}

export default IncidenceNote
